import { Box, Button, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { DISPLAYED_METADATA_LABELS } from 'components/OrderSlidesList/SlideActionTabs/constants';

export const MetadataTableButtons = ({
  label,
  editingRow,
  isNew,
  handleEdit,
  handleSubmit,
  handleCancel,
  classes,
  handleSave,
  sampleLink,
  antibodyUUID,
  isStaff,
}) => (
  <Box display="flex" justifyContent="flex-end">
    {editingRow === label ? (
      <>
        <Button
          onClick={handleSubmit(handleSave)}
          className={`${classes.actionButton} ${classes.saveButton}`}
        >
          Save
        </Button>
        <Button
          onClick={() => handleCancel(isNew)}
          className={`${classes.actionButton} ${classes.cancelButton}`}
        >
          Cancel
        </Button>
      </>
    ) : (
      <>
        {antibodyUUID && isStaff && (
          <Tooltip title="Remove Antibody" placement="top">
            <CloseIcon
              className={classes.removeButton}
              onClick={handleSubmit(() =>
                handleSave({ [DISPLAYED_METADATA_LABELS.antibody]: null }),
              )}
            />
          </Tooltip>
        )}
        {label === DISPLAYED_METADATA_LABELS.specialStain && isStaff && (
          <Tooltip title="Remove Special Stain" placement="top">
            <CloseIcon
              className={classes.removeButton}
              onClick={handleSubmit(() =>
                handleSave({
                  SpecialStain: null,
                  [DISPLAYED_METADATA_LABELS.stainType]: '',
                }),
              )}
            />
          </Tooltip>
        )}
        <Typography
          onClick={() =>
            sampleLink ? window.open(sampleLink, '_blank') : handleEdit(label)
          }
          className={classes.editLink}
        >
          {label === DISPLAYED_METADATA_LABELS.antibody ||
          label === DISPLAYED_METADATA_LABELS.specialStain
            ? 'Select'
            : 'Edit'}
        </Typography>
      </>
    )}
  </Box>
);
